var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline align-items-center"},[_c('span',{staticClass:"text mr-2"},[_vm._v(_vm._s(_vm.count))]),_c('fa-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"sm":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }